/*============================================================
   REACT DEPENDENCIES
============================================================*/
import { useState } from "react";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";

import GridSectionHeader from "../../../widgets/GridSectionHeader";
import SectionCKAEducation, { getCKAEducationValidity } from "./SectionCKAEducation";

import SectionCKAFinancial, { getCKAFinancialValidity } from "./SectionCKAFinancial";
import SectionCKAInvestment, { getCKAInvestmentValidity } from "./SectionCKAInvestment";
import SectionCKAWorkExperience, { getCKAWorkExperienceValidity } from "./SectionCKAWorkExperience";

import SectionCKAOutcome from "./SectionCKAOutcome";

import PageNavigator, { onNext } from "../../../PageNavigator";

export default function CustomerKnowledgeAndAccounts() {
  /**
   * TRUE - WHEN COMPONENT IS VALID AND "NEXT PAGE" BUTTON IS ENABLED
   *        ALL SUB COMPONENTS SHOULD BE VALID FOR THIS TO BE TRUE
   */
  const [enableNext, setEnableNext] = useState(false);

  function validateForm(e) {
    e.preventDefault();

    if (
      getCKAEducationValidity() &&
      getCKAFinancialValidity() &&
      getCKAInvestmentValidity() &&
      getCKAWorkExperienceValidity()
    ) {
      onNext();
    }
  }

  return (
    <>
      <Box component="form" onSubmit={validateForm} noValidate>
        <Grid container spacing={2}>
          <GridSectionHeader
            sectionName="Customer Knowledge Assessment(CKA) / Customer Accounts Review(CAR)"
            sx={{
              p: 1,
              pl: 1.8,
              mt: 0,
              mb: 1,
              fontSize: 18,
              fontWeight: "bold",
              color: "#FFFFFF", //WHITE
              // color: "#000000", //BLACK
              // backgroundColor: "#d9d9d9",
              backgroundColor: "#10B981",
            }}
          />

          <Typography variant="body1" sx={{ mb: 2 }} align="justify">
            It is important to find out if you have the knowledge or investment experience to understand the risk and
            features of "Specified Investmetn Products (SIP)". This assessment, known as the Customer Knowledge
            Assessnent(CKA)/Customer Account Review (CAR) helps to assess your knowledge of investment experience before
            solution(s) is/are offered to you. The accuracy or completeness of the information provided may affect the
            suitability of the recommendations made. A copy of the form will be submitted to the relevant investment
            platform when necessary. By proceeding to provide this information, you have given consent to the
            collection, use and disclosure of this information.
          </Typography>
        </Grid>

        {/**EDUCATION QUALIFICATION*/}
        <SectionCKAEducation setEnableNext={setEnableNext} />

        {/**PROFESSIONAL QUALIFICATION*/}
        <SectionCKAFinancial setEnableNext={setEnableNext} />

        {/*INVESTMENT QUALIFICATION*/}
        <SectionCKAInvestment setEnableNext={setEnableNext} />

        {/*WORK EXPERIENCE*/}
        <SectionCKAWorkExperience setEnableNext={setEnableNext} />

        {/*OUTCOME*/}
        <SectionCKAOutcome />

        <PageNavigator validator={validateForm} isValid={enableNext} />
      </Box>
    </>
  );
}
